import React from 'react';
import PropTypes from 'prop-types';

import cnMerge from '../../lib/utils';

const Card = React.forwardRef(({ className, ...props }, ref) => (
    <div
        ref={ref}
        className={cnMerge(
            'rounded-xl border border-border bg-card text-card-foreground shadow-sm',
            className
        )}
        {...props}
    />
));

Card.displayName = 'Card';

Card.propTypes = {
    className: PropTypes.string
};

Card.defaultProps = {
    className: undefined
};

const CardHeader = React.forwardRef(({ className, ...props }, ref) => (
    <div ref={ref} className={cnMerge('flex flex-col space-y-1.5 p-6', className)} {...props} />
));

CardHeader.displayName = 'CardHeader';

CardHeader.propTypes = {
    className: PropTypes.string
};

CardHeader.defaultProps = {
    className: undefined
};

const CardTitle = React.forwardRef(({ className, ...props }, ref) => (
    <h3
        ref={ref}
        className={cnMerge('text-lg font-semibold leading-none tracking-tight', className)}
        {...props}
    />
));

CardTitle.displayName = 'CardTitle';

CardTitle.propTypes = {
    className: PropTypes.string
};

CardTitle.defaultProps = {
    className: undefined
};

const CardDescription = React.forwardRef(({ className, ...props }, ref) => (
    <p ref={ref} className={cnMerge('text-sm text-muted-foreground', className)} {...props} />
));

CardDescription.displayName = 'CardDescription';

CardDescription.propTypes = {
    className: PropTypes.string
};

CardDescription.defaultProps = {
    className: undefined
};

const CardContent = React.forwardRef(({ className, ...props }, ref) => (
    <div ref={ref} className={cnMerge('p-6 pt-0', className)} {...props} />
));

CardContent.displayName = 'CardContent';

CardContent.propTypes = {
    className: PropTypes.string
};

CardContent.defaultProps = {
    className: undefined
};

const CardFooter = React.forwardRef(({ className, ...props }, ref) => (
    <div ref={ref} className={cnMerge('flex items-center p-6 pt-0', className)} {...props} />
));

CardFooter.displayName = 'CardFooter';

CardFooter.propTypes = {
    className: PropTypes.string
};

CardFooter.defaultProps = {
    className: undefined
};

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent };
